import {
  forwardRef,
  useRef,
  type ForwardedRef,
  type HTMLAttributes,
  type ReactNode,
} from 'react';
import mergeRefs from 'merge-refs';
import { useDialog } from 'react-aria';

type Props = {
  children: ReactNode;
  ariaLabel: string;
} & HTMLAttributes<HTMLDivElement>;

export const Dialog = forwardRef(function Dialog(
  props: Props,
  forwardRef: ForwardedRef<HTMLDivElement>
) {
  const { ariaLabel, children, ...divProps } = props;
  const dialogRef = useRef<HTMLDivElement | null>(null);
  const { dialogProps } = useDialog(
    {
      'aria-label': ariaLabel,
    },
    dialogRef
  );

  return (
    <div ref={mergeRefs(dialogRef, forwardRef)} {...divProps} {...dialogProps}>
      {children}
    </div>
  );
});
